import { Grid, TableHead, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { LowFontIcon, UpFontIcon } from '../../components/CustomIcons';
import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { grey } from '@mui/material/colors';
import { formatDateToDDMMYYYY, formatDateToDDMMYYYYFrEpoch, formatDateToDDMMYYYYHHSSFrEpoch } from "../../utils/commons";


const useStyles = makeStyles((theme) => ({
    table: {
        background: theme.palette.common.white,
        // width: 375,
        overflowX: 'auto',
    },
    namecss: {
        padding: theme.spacing(0.5, 1),
        background: grey[300],
        borderRadius: theme.spacing(0.5),
    },
    cell: {
        padding: theme.spacing(0.5, 1) + '!important',
    }
}));


export default function SupportRequestTableView(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { rows } = props;

    return (
        <div marginTop={1}>
            <div className={classes.table}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell>
                                <Typography variant="body2">{t('support_rq_type')}</Typography>
                            </TableCell>
                            <TableCell style={{ width: '30%' }}>
                                <Typography variant="body2">{t('service_request_number')}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2">{t('status')}</Typography>
                            </TableCell>
                            <TableCell style={{width: '30%'}}>
                                <Typography variant="body2">{t('date_title')}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2">{t('status')}</Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows && rows.length > 0 && rows.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell>
                                    <Typography variant="caption" className={classes.namecss}>{row.classification}</Typography>
                                </TableCell>
                                <TableCell style={{ width: '50%' }}>
                                    <Typography variant="body2">{row.number}</Typography>
                                    <Typography variant="caption">{row.description}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2" style={{ color: row.status && row.status.priority === '1' ? 'green' : 'orange', textTransform: 'capitalize' }}>{row.status.name}
                                        {/* { row.status && row.status.priority === '1' ? <LowFontIcon style={{color: 'green'}}/> : <UpFontIcon style={{color: 'orange'}}/>}  */}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body1">{row.created_date ? formatDateToDDMMYYYYFrEpoch(row.created_date, true) : ""}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body1">{row.status && row.status.name ? row.status.name : null}</Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                        {rows && rows.length <= 0 && <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell>{t('no_data_found')}</TableCell>
                        </TableRow>}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
}
